import {useGroupAuthorize, useGroups} from '@/hooks/useAuth';
import {useEntitledForClient} from '@/hooks/useEntitlements';
import {graphqlClient} from '@/services/graphqlClient';
import {useGetConfigByKeyQuery} from '@/services/graphqlHooks';
import {employeeWorkTimeTrackingConfigVariables} from '@/utils/isEmployeeWorkTimeTrackingForced';

import {
  isEmployeeWorkTimeTrackingForced,
  workTimeTrackingGroups,
} from '../utils/workTimeGroups';

export function useForceEmployeeWorkTimeTrackingConfig() {
  const isWorkTimeEntitled = useEntitledForClient('WORK_TIME');
  const isWorkTimeTrackingGroup = useGroupAuthorize(workTimeTrackingGroups);
  const config = useGetConfigByKeyQuery(
    graphqlClient,
    employeeWorkTimeTrackingConfigVariables,
    {
      enabled: isWorkTimeEntitled && isWorkTimeTrackingGroup,
      staleTime: 30_000,
    }
  );

  return (
    isWorkTimeEntitled &&
    isWorkTimeTrackingGroup &&
    !config.isError &&
    config.data?.getConfigByKey?.value.boolValue === true
  );
}

export function useEmployeeWorkTimeTrackingForced() {
  const groups = useGroups() || [];
  const forceTrackingEnabled = useForceEmployeeWorkTimeTrackingConfig();

  return isEmployeeWorkTimeTrackingForced(groups, forceTrackingEnabled);
}
